import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "mb-3 rounded-lg border border-solid border-neutralLight bg-[#F6F6F9] px-3 py-2 text-left text-sm text-textPrimary",
  "data-testid": "unidentified-mirror-notice"
}
const _hoisted_2 = {
  key: 0,
  class: "mt-2 flex flex-col gap-0.5 text-xs text-[#68688D]"
}

import { computed, ref } from 'vue'
import { format } from 'date-fns'
import type { DSAttendanceUnidentifiedCoverageStation } from '@/Network/Types/Responses/DsAttendancePolicyResponses'
import { formatTimeCell } from '../utils/prefill-mirror'

/**
 * M13-A — aviso acima do espelho da folha: plantões ocupados sem identificação ficam FORA do
 * universo esperado e não são candidatos da conciliação (Q22). O front só avisa; nada muda
 * no espelho nem na conciliação.
 */


export default /*#__PURE__*/_defineComponent({
  __name: 'UnidentifiedCoverageMirrorNotice',
  props: {
    count: {},
    stations: {}
  },
  setup(__props: any) {

const props = __props;



const expanded = ref(false)
const isSingle = computed(() => props.count === 1)
const headline = computed(() =>
  isSingle.value
    ? '+1 plantão ocupado sem identificação nesta escala e período.'
    : `+${props.count} plantões ocupados sem identificação nesta escala e período.`
)
const explanation = computed(() =>
  isSingle.value
    ? 'Ele não entra no espelho nem na conciliação, porque não há médico a conferir.'
    : 'Eles não entram no espelho nem na conciliação, porque não há médico a conferir.'
)
const toggleLabel = computed(() =>
  isSingle.value ? 'Ver o plantão' : `Ver os ${props.count} plantões`
)

function describeStation(station: DSAttendanceUnidentifiedCoverageStation): string {
  const day = format(new Date(station.startHour), 'dd/MM')
  const range = `${formatTimeCell(station.startHour)}–${formatTimeCell(station.endHour)}`
  return [`${day} ${range}`, station.coverageResponsibleName].filter(Boolean).join(' · ')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, [
      _createElementVNode("b", null, _toDisplayString(headline.value), 1),
      _createTextVNode(" " + _toDisplayString(explanation.value) + " ", 1),
      (_ctx.stations.length)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "ml-1 font-bold text-primary30 underline",
            "data-testid": "unidentified-mirror-notice-toggle",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (expanded.value = !expanded.value))
          }, _toDisplayString(expanded.value ? 'Ocultar' : toggleLabel.value), 1))
        : _createCommentVNode("", true)
    ]),
    (expanded.value)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stations, (station) => {
            return (_openBlock(), _createElementBlock("li", {
              key: station.doctorStationId,
              "data-testid": "unidentified-mirror-notice-item"
            }, _toDisplayString(describeStation(station)), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})